module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/709de1e4190e2fc8ef84100ad94157a4.png";